import React from 'react';

export const TagAddIcon = (props) => {
  return (
    <svg viewBox='0 0 30 30' fill='currentColor' height='1em' width='1em' {...props}>
      <g id='icon/tag/add' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <path
          d='M11.5000006,5 C12.0281463,4.99957917 12.5350183,5.20807973 12.9100013,5.58000064 L12.9100013,5.58000064 L19.4031564,12.0737262 C18.7942766,12.3838167 18.2380669,12.7824933 17.7515071,13.2527762 L11.5000013,7.00000064 L4.50000126,7.00000064 L4.50000126,14.0000006 L13.5000013,23.0000006 L16.0558381,20.4454076 C16.29078,21.1098009 16.6255591,21.7270201 17.0421476,22.2790373 L14.9100013,24.4100006 C14.536651,24.7855884 14.0295781,24.9977678 13.5000006,25 C12.9718562,25.0004221 12.4649842,24.7919215 12.0900013,24.4200006 L12.0900013,24.4200006 L3.09000126,15.4200006 C2.71196186,15.0442043 2.49957888,14.5330452 2.50000063,14 L2.50000063,14 L2.50000063,7 C2.50000063,5.89543114 3.39543176,5 4.50000063,5 L4.50000063,5 Z M7.00000126,8.00000064 C7.82842838,8.00000064 8.50000126,8.67157351 8.50000126,9.50000064 C8.50000126,10.3284278 7.82842838,11.0000006 7.00000126,11.0000006 C6.17157413,11.0000006 5.50000126,10.3284278 5.50000126,9.50000064 C5.50000126,8.67157351 6.17157413,8.00000064 7.00000126,8.00000064 Z'
          id='Combined-Shape'
          fill='currentColor'
          fillRule='nonzero'
        ></path>
        <g
          id='ci:list-plus'
          transform='translate(16.487713, 12.666668)'
          fill='currentColor'
          fillRule='nonzero'
        >
          <polygon
            id='Shape'
            points='7.18055556 10.468254 4.70039683 10.468254 4.70039683 6.74801587 0.98015873 6.74801587 0.98015873 4.26785714 4.70039683 4.26785714 4.70039683 0.547619048 7.18055556 0.547619048 7.18055556 4.26785714 10.9007937 4.26785714 10.9007937 6.74801587 7.18055556 6.74801587'
          ></polygon>
        </g>
      </g>
    </svg>
  );
};
